import React from "react";
import Box from "@mui/material/Box";
import PageTitle from "../../../../shared/ui/PageTitle";
import BoxContent from "../../../../shared/ui/BoxContent";
import GenericButton from "../../../../shared/ui/GenericButton";
import {useNavigate} from "react-router-dom";
import ReportsList from "../../shared/ReportsList";

const ClassroomsReports = () => {
    const navigate = useNavigate();

    return (
        <Box component="main">
            <PageTitle
                actions={
                    <GenericButton
                        type="report-generate"
                        onClick={() => {
                            navigate("/rapoarte-clasa/genereaza", {
                                state: {
                                    type: "classroom",
                                    classroom_id: null,
                                }
                            });
                        }}
                    />
                }>
                Rapoarte clasă
            </PageTitle>
            <BoxContent>
                <Box width="100%">
                    <ReportsList type="classrooms" classroomId="" />
                </Box>
            </BoxContent>

        </Box>
    );
};

export default ClassroomsReports;
